import React from 'react'
import Calendar from 'react-calendar'
import { creationEventStore } from 'state/event/eventCreationStore'
import moment from 'moment'
import './styles/styles.scss'

interface MonthlyCalendarProps {
  selectedDate: Date
  setSelectedDate: any
  availableDates: string[]
}

const SelectDateFromGivenDates: React.FC<MonthlyCalendarProps> = ({
  selectedDate,
  setSelectedDate,
  availableDates,
}) => {
  const bDates = []
  availableDates.map((date: string) => {
    const utcDate = new Date(date)
    utcDate.setMinutes(utcDate.getMinutes() + utcDate.getTimezoneOffset())
    bDates.push(utcDate)
  })

  return (
    <div className="schedule-calendar">
      <Calendar
        calendarType="US"
        onChange={setSelectedDate}
        defaultActiveStartDate={selectedDate}
        minDetail="month"
        minDate={
          availableDates && moment(availableDates[0], 'YYYY-MM-DD').toDate()
        }
        maxDate={
          availableDates &&
          moment(
            availableDates[availableDates.length - 1],
            'YYYY-MM-DD',
          ).toDate()
        }
        tileDisabled={({ date }) =>
          !bDates.some(
            bDate =>
              bDate.getDate() === date.getDate() &&
              bDate.getMonth() === date.getMonth(),
          )
        }
        tileClassName={({ date, view }) => {
          let classes = []
          if (
            availableDates.find(
              x =>
                moment(x).format('YYYY-MM-DD') ===
                moment(date).format('YYYY-MM-DD'),
            )
          ) {
            classes.push('availalbe-date')
          }
          if (
            moment(selectedDate).format('YYYY-MM-DD') ===
            moment(date).format('YYYY-MM-DD')
          ) {
            classes.push('current-selected')
          }
          return classes.join(' ')
        }}
      />
    </div>
  )
}

export default SelectDateFromGivenDates
